import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {
  setFirstName,
  setLastName,
  setDateOfBirth,
  setGroup,
  setGender,
  setGuest,

  setFirstNameErrors,
  setLastNameErrors,
  setDateOfBirthErrors,
  setGroupErrors,
  setGenderErrors,
  setGuestErrors,

  removeFamilyMember
} from '../../../actions/familyMembers';
import ContactForm from './ContactForm';


const FamilyMemberFormInner = connect(
  (state, {id}) => {
    let {
      First_Name, Last_Name, Email_Address, Mobile_Phone,
      Date_of_Birth, Group_ID, Gender_ID, Marital_Status_ID, Guest
    } = state.familyMembers.byId[id];

    return {
      First_Name: First_Name.value,
      First_Name_Errors: First_Name.errors,

      Last_Name: Last_Name.value,
      Last_Name_Errors: Last_Name.errors,

      Date_of_Birth: Date_of_Birth.value,
      Date_of_Birth_Errors: Date_of_Birth.errors,

      Group_ID: Group_ID.value,
      Group_ID_Errors: Group_ID.errors,

      Gender_ID: Gender_ID.value,
      Gender_ID_Errors: Gender_ID.errors,

      Guest: Guest.value,
      Guest_Errors: Guest.errors,

      className: 'family-member-form',
      title: First_Name.value ? `${First_Name.value}'s Info` : 'Family Member Info',
      hideEmailAddress: true,
      hideMobilePhone: true,
      hideMaritalStatus: true,
      showGuest: true,
      hideMaritalStatus: true,

      First_Name_Label: 'Child First Name...',
      Last_Name_Label: 'Child Last Name...',
      Gender_Label: 'Child Gender',
      Date_of_Birth_Label: 'Child D.O.B....'
    };
  },
  (dispatch, {id}) => ({
    setFirstName(value) {
      dispatch(setFirstName(id, value));
    },
    setFirstNameErrors(errors) {
      dispatch(setFirstNameErrors(id, errors));
    },

    setLastName(value) {
      dispatch(setLastName(id, value));
    },
    setLastNameErrors(value) {
      dispatch(setLastNameErrors(id, value));
    },

    setDateOfBirth(value) {
      dispatch(setDateOfBirth(id, value));
    },
    setDateOfBirthErrors(value) {
      dispatch(setDateOfBirthErrors(id, value));
    },

    setGroup(value) {
      dispatch(setGroup(id, value));
    },

    setGroupErrors(value) {
      dispatch(setGroupErrors(id, value));
    },

    setGender(value) {
      dispatch(setGender(id, value));
    },
    setGenderErrors(value) {
      dispatch(setGenderErrors(id, value));
    },

    setGuest(value) {
      dispatch(setGuest(id, value));
    },
    setGuestErrors(value) {
      dispatch(setGuestErrors(id, value));
    }
  })
)(ContactForm);


@connect(
  null,
  (dispatch, {id}) => ({
    removeFamilyMember() {
      dispatch(removeFamilyMember(id));
    }
  })
)
export default class FamilyMemberForm extends PureComponent {
  render() {
    let {removeFamilyMember, hideRemove} = this.props;

    return (
      <div className="contact-form-wrapper">
        <FamilyMemberFormInner {...this.props} />
        {!hideRemove && <button type="button" onClick={() => removeFamilyMember()}>Remove</button>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form-route/forms/FamilyMemberForm.js